import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ConfigDetails } from '../../../models/app-config.model';
import { BCMCLPUser, CLPUser, TeamCodes, UserResponse } from '../../../models/clpuser.model';
import { eFeatures } from '../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../models/role-container.model';
import { CMClubService } from '../../../services/cm-club.service';
import { AppConfigService } from '../../../services/shared/app-config.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';

@Component({
  selector: 'app-mem-left-side-menu',
  templateUrl: './mem-left-side-menu.component.html',
  styleUrl: './mem-left-side-menu.component.css'
})
export class MemLeftSideMenuComponent {
    encryptedUser: string = '';
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    user: BCMCLPUser;
    routeName: string;
    curClub: any;
    curTeam: TeamCodes = <TeamCodes>{};
    clpCompanyId: number;
    private destroy$ = new Subject<void>();

    constructor(public _localService: LocalService, private _route: ActivatedRoute,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private teamOfficeService: TeamOfficeService,
        private _appconfigService: AppConfigService,
        private clubService: CMClubService
    ) {

        this._localService.routeName.pipe(takeUntil(this.destroy$)).subscribe(value => this.routeName = value);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData();
                }
                else {
                    //this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            //this._router.navigate(['/unauthorized']);
        }
    }

    loadData() {

        this.teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0) {
                this.curTeam = data;
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem('curTeam') || '{}');
            }
        })
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user?.cLPCompanyID;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    goToLink(routeName) {
        switch (routeName) {
            case 'mem-dashboard':
                this._router.navigate(['/mem-dashboard']);
                this._localService.setRouteName("mem-dashboard");
                break;
            case 'mem-membership-list':
                this._router.navigate(['/mem-membership-list']);
                this._localService.setRouteName("mem-membership-list");
                break;
            case 'mem-contact-list':
                this._router.navigate(['/mem-contact-list']);
                this._localService.setRouteName("mem-contact-list");
                break;
            case 'mem-pause-list':
                this._router.navigate(['/mem-pause-list']);
                this._localService.setRouteName("mem-pause-list");
                break;
            case 'mem-insurance-list':
                this._router.navigate(['/mem-insurance-list']);
                this._localService.setRouteName("mem-insurance-list");
                break;
            case 'mem-policy-violation-list':
                this._router.navigate(['/mem-policy-violation-list']);
                this._localService.setRouteName("mem-policy-violation-list");
                break;
            case 'mem-case-list':
                this._router.navigate(['/mem-case-list']);
                this._localService.setRouteName("mem-case-list");
                break;
            case 'mem-subscription-list':
                this._router.navigate(['/mem-subscription-list']);
                this._localService.setRouteName("mem-subscription-list");
                break;
            case 'mem-incident':
                //this._router.navigate(['/mem-incident']);
                //this._localService.setRouteName("mem-incident");
                break;
            case 'mem-reservations':
                //this._router.navigate(['/mem-reservations']);
                //this._localService.setRouteName("mem-reservations");
                break;
        }
    }
}
